var _g, _g2, _g3, _g4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInterface(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "interface_1_",
    "data-name": "interface (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_577",
    "data-name": "Group 577"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_576",
    "data-name": "Group 576"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_422",
    "data-name": "Path 422",
    d: "M10.359,0H3.469A3.473,3.473,0,0,0,0,3.469v6.89a3.473,3.473,0,0,0,3.469,3.469h6.89a3.473,3.473,0,0,0,3.469-3.469V3.469A3.473,3.473,0,0,0,10.359,0Zm1.125,10.359a1.127,1.127,0,0,1-1.125,1.125H3.469a1.127,1.127,0,0,1-1.125-1.125V3.469A1.127,1.127,0,0,1,3.469,2.344h6.89a1.127,1.127,0,0,1,1.125,1.125Z",
    fill: "#174a84"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_579",
    "data-name": "Group 579",
    transform: "translate(16.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_578",
    "data-name": "Group 578"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_423",
    "data-name": "Path 423",
    d: "M286.313,0h-6.8A3.52,3.52,0,0,0,276,3.516v6.8a3.52,3.52,0,0,0,3.516,3.516h6.8a3.52,3.52,0,0,0,3.516-3.516v-6.8A3.52,3.52,0,0,0,286.313,0Zm1.172,10.313a1.173,1.173,0,0,1-1.172,1.172h-6.8a1.173,1.173,0,0,1-1.172-1.172v-6.8a1.173,1.173,0,0,1,1.172-1.172h6.8a1.173,1.173,0,0,1,1.172,1.172Z",
    transform: "translate(-276)",
    fill: "#174a84"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_581",
    "data-name": "Group 581",
    transform: "translate(0 16.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_580",
    "data-name": "Group 580"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_424",
    "data-name": "Path 424",
    d: "M10.359,276H3.469A3.473,3.473,0,0,0,0,279.469v6.89a3.473,3.473,0,0,0,3.469,3.469h6.89a3.473,3.473,0,0,0,3.469-3.469v-6.89A3.473,3.473,0,0,0,10.359,276Zm1.125,10.359a1.127,1.127,0,0,1-1.125,1.125H3.469a1.127,1.127,0,0,1-1.125-1.125v-6.89a1.127,1.127,0,0,1,1.125-1.125h6.89a1.127,1.127,0,0,1,1.125,1.125Z",
    transform: "translate(0 -276)",
    fill: "#174a84"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_583",
    "data-name": "Group 583",
    transform: "translate(16.172 16.172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_582",
    "data-name": "Group 582"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_425",
    "data-name": "Path 425",
    d: "M286.313,276h-6.8A3.52,3.52,0,0,0,276,279.516v6.8a3.52,3.52,0,0,0,3.516,3.516h6.8a3.52,3.52,0,0,0,3.516-3.516v-6.8A3.52,3.52,0,0,0,286.313,276Zm1.172,10.313a1.173,1.173,0,0,1-1.172,1.172h-6.8a1.173,1.173,0,0,1-1.172-1.172v-6.8a1.173,1.173,0,0,1,1.172-1.172h6.8a1.173,1.173,0,0,1,1.172,1.172Z",
    transform: "translate(-276 -276)",
    fill: "#174a84"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInterface);
export default __webpack_public_path__ + "static/media/interface.f3d106d2c0ccb9c712dad260375e06be.svg";
export { ForwardRef as ReactComponent };